export default __webpack_public_path__ + "static/media/paper_en.66f646f8.pdf";